import ApiJobMode from 'types/api/JobMode';
import { ApiResources } from 'types/apiResources';
import { Endpoints, ListParamsDefault } from 'types/endpoints';
import ListCollection from 'types/redux/ListCollection';

import JobMode from 'models/JobMode';

import { LIST_MARKUP } from 'consts/redux';
import { withVariables } from 'utils/string';
import { request } from 'services/Api';

export interface ListParams extends ListParamsDefault {}
export const list = async (params?: ListParams): Promise<ListCollection<JobMode>> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicJobModes, params),
        requestParams: params,
    });

    const data = response?.payload?.data;
    const resource = data && data[ApiResources.JobModes];

    if(!data || !resource) {
        throw new Error('Not Found');
    }

    return {
        ...LIST_MARKUP,
        isLoaded: true,
        elements: resource
            .elements
            .map((element: ApiJobMode) => new JobMode(element)),
        meta: resource.meta,
    };
};

export interface SingleParams {
    slug: string;
}
export const single = async (params: SingleParams): Promise<JobMode> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicJobMode, params),
    });

    const data = response?.payload?.data;
    const resource: ApiJobMode = data && data[ApiResources.JobMode];

    if(!data || !resource) {
        throw new Error('Not Found');
    }

    return new JobMode(resource);
};
